// extracted by mini-css-extract-plugin
module.exports = {"startForm":"Index_startForm___iCIf","title":"Index_title__M9on2"};